import { STATUS, CRIT } from "@/lib/format";

export function StatusBadge({ status, size = "sm", full = false, testid }) {
  const s = STATUS[status] || STATUS.ADEQUADO;
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1.5 rounded-full border font-semibold ${s.bg} ${s.color} ${s.border} ${
        size === "lg" ? "px-3 py-1 text-sm" : "px-2.5 py-0.5 text-xs"
      }`}
    >
      <span className={`h-2 w-2 rounded-full status-dot ${status === "CRITICO" ? "bg-rose-400" : status === "ATENCAO" ? "bg-amber-400" : status === "EXCESSO" ? "bg-slate-400" : "bg-emerald-400"}`} />
      {full ? s.label : s.short}
    </span>
  );
}

export function CritBadge({ level }) {
  const c = CRIT[level] || CRIT.MEDIA;
  return (
    <span className={`inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-medium ${c.bg} ${c.color}`}>
      Criticidade {c.label}
    </span>
  );
}
